import React, { useState } from 'react';
import { buildVersion } from 'lib/buildDate';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Link } from 'react-router-dom'; //import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import logo from 'theme/MyLogo';
import ReactGA from 'lib/analytics';
import {
  useTranslate,
  useLogin,
  useNotify,
  useRedirect,
  Notification,
} from 'react-admin';

// shared components
import Copyright from 'components/Copyright';
import { InstallPrompt } from 'components/InstallPrompt';

// Local styles
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    marginBottom: theme.spacing(2),
  },
  title: {
    //padding: theme.spacing(4),
  },
  intro: {
    fontSize: 40,
    fontFamily: "'Festive', cursive",
    paddingTop: theme.spacing(2),
  },
  companyName: { fontSize: 20, fontWeight: 'bold' },
  welcomeText: {
    fontSize: 40,
    fontFamily: "'Festive', cursive",
    paddingTop: theme.spacing(2),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(4),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  spellItOut: {
    clear: 'both',
    width: '100$',
    marginTop: '20px !important',
    textAlign: 'center',
    background: '#fff',
    padding: 20,
    border: '1px solid #ddd',
  },
  goShop: {
    clear: 'both',
    width: '100$',
    marginTop: '20px !important',
    textAlign: 'center',
    background: '#fff',
    padding: 20,
    border: '1px solid #ddd',
    marginBottom: 20,
  },
}));

export const Help = () => {
  const classes = useStyles();
  const redirect = useRedirect();
  return (
    <div
      className={classes.spellItOut}
      onClick={(e) => {
        e.preventDefault();
        redirect('/first');
      }}
    >
      <Grid container>
        <Grid item xs={12}>
          <Typography component="body1" variant="p">
            <div>
              <strong>{`First time here?`}</strong>
            </div>
            <div>
              <strong>{`Can't remember your password?`}</strong>
            </div>
            <div>
              {``}
              <Link to="/first" variant="body2">
                Click here to set your password
              </Link>
            </div>
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export const Shop = () => {
  const classes = useStyles();
  return (
    <div
      className={classes.goShop}
      onClick={(e) => {
        e.preventDefault();
        window.open('https://www.pinesandneedles.com/');
      }}
    >
      <Grid container>
        <Grid item xs={12}>
          <Typography component="body1" variant="p">
            {/* <div> */}
            {/* <strong>{`Haven't ordered yet?`}</strong> */}
            {/* </div> */}
            <div>
              <strong>{`Need to buy a Christmas Tree?`}</strong>
            </div>
            <div>
              {/* {`Head over to our website and `} */}
              <Link
                to="https://www.pinesandneedles.com"
                target="_blank"
                variant="body2"
              >
                Start shopping now
              </Link>
            </div>
            {/* <div> */}
            {/* <span>{`Your account is created when you shop with us`}</span> */}
            {/* </div> */}
            {/* <div> */}
            {/* <span>{`Then you can login here to track your delivery`}</span> */}
            {/* </div> */}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export const Logo = () => {
  const classes = useStyles();
  return (
    <div
      style={{
        //width: '100%',
        display: 'flex',
        align: 'center',
        justifyContent: 'center',
        background: '#013334',
        borderRadius: 40,
        width: 80,
        height: 80,
      }}
      className={classes.logo}
    >
      <img
        src={logo}
        width={50}
        height={'auto'}
        style={{ height: 50, width: 50, marginTop: 15 }}
      />
    </div>
  );
};

export const Login = () => {
  const classes = useStyles();
  const translate = useTranslate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const login = useLogin();
  const notify = useNotify();
  const redirect = useRedirect();
  const submit = (e) => {
    e.preventDefault();
    console.log('login', { username });
    login({ username, password })
      .then((data) => {
        if (data && data.status === 'y') {
          ReactGA.event({ category: 'login', action: 'success' });
          console.log('Login success', data);
          notify('ra.auth.login_success', { type: 'success' }); //'Login accepted');
          redirect('/');
        } else {
          ReactGA.event({ category: 'login', action: 'failed' });
          console.warn('Login invalid', data);
          notify('ra.auth.login_invalid', { type: 'error' }); //'Invalid username or password');
        }
      })
      .catch((err) => {
        ReactGA.event({ category: 'login', action: 'error' });
        console.warn('Login error', err);
        notify('ra.auth.login_error', { type: 'error' }); //'Invalid username or password')
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Notification />
      <div className={classes.paper}>
        <Logo />
        {/* <Avatar className={classes.avatar}> */}
        {/* <LockOutlinedIcon /> */}
        {/* </Avatar> */}
        <Typography className={classes.companyName}>
          Pines and Needles
        </Typography>
        <Typography className={classes.welcomeText}>
          {translate('ra.auth.login_intro')}
        </Typography>
        <Typography className={classes.title}>
          {translate('ra.auth.login_title')}
        </Typography>
        <form
          id="login-form"
          className={`action-form ${classes.form}`}
          noValidate
          onSubmit={submit}
        >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label={translate('ra.auth.username')}
            name="username"
            autoComplete="username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label={translate('ra.auth.password')}
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {/* 
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label={translate('ra.auth.login_remember')}
          />
          */}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            id="login-button"
          >
            {translate('ra.auth.login_button')}
          </Button>

          <Help />
          <Shop />
          <Grid container>
            <Grid item xs>
              <Link id="forgot-link" to="/forgot" variant="body2">
                {translate('ra.auth.login_forgot_link')}
              </Link>
            </Grid>
            <Grid item>
              <a
                target="_blank"
                href="https://manage.kmail-lists.com/subscriptions/subscribe?a=J6T84a&amp;g=KKAhcD"
                rel="noreferrer"
                data-label="Newsletter Singup"
                onClick={ReactGA.trackExternalLink}
              >
                Newsletter Signup
              </a>
              {/* 
              <Link id="register-link" to="/register" variant="body2">
                {translate('ra.auth.login_register_link')}
              </Link>
              */}
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8} align="center">
        <Copyright />
        <Typography style={{ fontSize: 10 }}>v{buildVersion}</Typography>
      </Box>
      <InstallPrompt />
    </Container>
  );
};

export default Login;
